<script>
    import AssetTypeObject from '@/components/page-asset-type-edit/AssetTypeObject.vue';

    export default {
        computed: {
            assetTypes() {return this.$store.getters.ASSET_TYPES},
        },
        components: {
            AssetTypeObject: AssetTypeObject,
        }
    }
</script>


<template>
    <div class="right_header">
        <label>Asset Type:</label>
    </div>
    <ul class="clear_ul">
        <AssetTypeObject 
            v-for="(assetTypeValue, assetTypeIndex) in assetTypes" :key="assetTypeIndex"
            :assetType="assetTypeValue"
        />
    </ul>
</template>